(function () {
  function formatMoney(cents) {
    // Falls back to a plain rupee format if Shopify.formatMoney isn't available.
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return '₹' + (cents / 100).toFixed(2);
  }

  function initComboBuilder(root) {
    if (root.dataset.comboInit === 'true') return;
    root.dataset.comboInit = 'true';

    var picker = root.querySelector('[data-combo-picker]');
    var pickerWrap = root.querySelector('[data-combo-picker-wrap]');
    var toggleTriggers = root.querySelectorAll('[data-combo-toggle-picker]');
    var options = root.querySelectorAll('[data-combo-option]');
    var selectedInput = root.querySelector('[data-combo-selected-variant]');
    var image = root.querySelector('[data-combo-image]');
    var titleEl = root.querySelector('[data-combo-title]');
    var priceEl = root.querySelector('[data-combo-price]');
    var finalEl = root.querySelector('[data-combo-final]');
    var originalEl = root.querySelector('[data-combo-original]');
    var discountPercent = parseFloat(root.getAttribute('data-discount-percent')) || 0;

    function selectOption(option) {
      if (!option) return;

      options.forEach(function (opt) {
        opt.classList.remove('is-selected');
        opt.setAttribute('aria-pressed', 'false');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-pressed', 'true');

      var wallPriceCents = parseInt(option.getAttribute('data-price'), 10) || 0;
      var wallTitle = option.getAttribute('data-title') || '';
      var wallImage = option.getAttribute('data-image') || '';
      var wallVariantId = option.getAttribute('data-variant-id');

      if (selectedInput) selectedInput.value = wallVariantId;
      if (image && wallImage) image.src = wallImage;
      if (titleEl) titleEl.textContent = wallTitle;
      if (priceEl) priceEl.textContent = formatMoney(wallPriceCents);

      var leftPriceEl = root.querySelector('[data-combo-left-price]');
      var leftCents = leftPriceEl ? parseInt(leftPriceEl.getAttribute('data-combo-left-price'), 10) : 0;
      if (isNaN(leftCents)) leftCents = 0;

      var totalCents = leftCents + wallPriceCents;

      // Discount applies only to the default (main/left) product's price.
      // The combo/swap product is always charged at full price.
      var discountedLeftCents = Math.round(leftCents * (1 - discountPercent / 100));
      var discountedCents = discountedLeftCents + wallPriceCents;

      if (finalEl) finalEl.textContent = formatMoney(discountedCents);
      if (originalEl) {
        if (discountPercent > 0) {
          originalEl.textContent = formatMoney(totalCents);
          originalEl.style.display = '';
        } else {
          originalEl.style.display = 'none';
        }
      }
    }

    function openPicker() {
      if (pickerWrap) pickerWrap.hidden = false;
    }

    function closePicker() {
      if (pickerWrap) pickerWrap.hidden = true;
    }

    toggleTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (evt) {
        evt.stopPropagation();
        if (!pickerWrap) return;
        if (pickerWrap.hidden) {
          openPicker();
        } else {
          closePicker();
        }
      });
    });

    if (options.length) {
      var initiallySelected = root.querySelector('[data-combo-option].is-selected') || options[0];
      selectOption(initiallySelected);

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          selectOption(option);
          closePicker();
        });
      });
    }

    // Add-to-cart submission is handled entirely by product-form.js, since this
    // widget's root element is a <product-form> containing a real <form> with
    // items[0][id] / items[1][id] hidden inputs. That's the exact same class
    // that powers the PDP's normal Add to cart button, so behavior — spinner,
    // errors, cart drawer rendering, quick-add-modal handling — is identical.
  }

  document.querySelectorAll('[data-combo-builder]').forEach(initComboBuilder);
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-combo-builder]').forEach(initComboBuilder);
  });
})();